import { IJourney } from "../interfaces/journey";
import api from "./api";

const pageSize = 5;

export async function fetchJourney(
  pageNumber: number,
  search: string
): Promise<any> {
  let url = "";
  const params: any = { page: pageNumber, pageSize };

  if (search.trim()) {
    url = `/Journey/searchJourneybyname`;
    params.name = search;
  } else {
    url = `/JourneyConfiguration/paged`;
  }

  const response = await api.get(url, { params });
  return response;
}

export async function checkJourneyExists(
  clientId: number,
  productId?: number
): Promise<boolean> {
  const { data } = await api.get<boolean>("/JourneyConfiguration/hasExists", {
    params: { clientId, productId },
  });
  return data;
}

export async function saveJourney(
  data: IJourney,
  editando: boolean,
  id?: number
) {
  const dataToSend = { ...data };
  if (editando && id) {
    dataToSend.id = id;
    return api.put(`JourneyConfiguration/`, dataToSend);
  } else {
    return api.post(`JourneyConfiguration/`, dataToSend);
  }
}

export async function deleteJourney(journeyId: number) {
  return api.delete(`JourneyConfiguration/${journeyId}`);
}

export async function searchJourneyByName(query: string) {
  const response = await api.get(`/Journey/ListJourneysName?name=${query}`);
  return response.data || [];
}

export async function searchProductsByJourney(id: number) {
  const response = await api.get(
    `/Product/ListProductByJourney?IdJourney=${id}`
  );
  return response.data || [];
}
